module.exports = __webpack_public_path__ + "img/HCMTX_IOS.71950278.png";